import PropTypes from 'prop-types'
import { Input } from 'baseui/input'
import { mergeOverrides, useStyletron } from 'baseui'
import { FloatingLabel, SDInputOverrides } from './styled-components'
import { Alert, Delete } from 'baseui/icon'
import IconCarbonCheckmarkOutline from '@/shared/icons/IconCarbonCheckmarkOutline'
import InfoIcon from '../icon_info.svg'
import { useEffect, useState } from 'react'

const SDInput = ({ label, overrides, status, currentValue, onBlur, outerOnchange, error, ...rest }) => {
  const [css] = useStyletron()
  const [value, setValue] = useState(currentValue || '')

  const iconMapping = {
    valid: <IconCarbonCheckmarkOutline size={24} color='green' />,
    info: <img src={InfoIcon} alt='Info' style={{ width: 24, height: 24 }} />,
    warning: <Alert size={24} color='orange' />,
    error: <Delete size={24} color='red' />,
  }

  const endEnhancer =
    status && iconMapping[status] ? () => <div className='sdinput-end-enhancer'>{iconMapping[status]}</div> : null

  const newOverrides = mergeOverrides(SDInputOverrides(error || false), overrides)

  useEffect(() => {
    if ((currentValue === null || currentValue === undefined) && value !== '') {
      setValue('')
      return
    }
    setValue(currentValue)
  }, [currentValue])

  return (
    <div className={css({ position: 'relative' })}>
      {label && (
        <FloatingLabel>
          <div dangerouslySetInnerHTML={{ __html: label }} />
        </FloatingLabel>
      )}
      <Input
        {...rest}
        error={error}
        overrides={newOverrides}
        onBlur={e => {
          if (typeof onBlur === 'function') {
            let selectedValue = e.target.value
            if (selectedValue === '') {
              selectedValue = null
            }
            onBlur(selectedValue)
          }
        }}
        onChange={e => {
          const newValue = e.target.value
          setValue(newValue)
          if (typeof outerOnchange === 'function') {
            let selectedValue = newValue
            if (selectedValue === '') {
              selectedValue = null
            }
            outerOnchange(selectedValue)
          }
        }}
        endEnhancer={endEnhancer ?? rest.endEnhancer ?? null}
        value={value || ''}
      />
    </div>
  )
}

SDInput.propTypes = {
  label: PropTypes.node,
  overrides: PropTypes.object,
  status: PropTypes.oneOf(['valid', 'info', 'warning', 'error']),
  currentValue: PropTypes.any,
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  error: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
}

export default SDInput
